import React from "react";

export default function MenuItem({ data, handleEvents }) {
  const submenus = ["usergroups", "dashboardaccess"];
  let addClass = "";
  if (submenus.indexOf(data.id) >= 0) {
    addClass += "col s12";
  } else { 
    addClass += "collection-item btn-menu-left";
  }
  if (data.id === data?.tabActive && data?.disable === false) {
    addClass += " active";
  } else if (
    data.id === "adminconsole" &&
    submenus.indexOf(data.tabActive) >= 0 && 
    data?.disable === false
  ) {
    addClass += " active";
  }
  else if (data?.disable === true) {
    addClass += " disable";
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      href={"#"}
      className={addClass}
      id={data.id}
      waves="light"
      onClick={() => handleEvents.OnClick(data)}
    >
      {data.text}
    </a>
  );
}
